// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('stocklogistics.masshandlingorderingpoints', {
        url: '/masshandling',
        templateUrl: 'main/stocklogistics/masshandlingorderingpoints/masshandlingorderingpoints.tpl.html',
        controller: 'MassHandlingOrderingPointsController as vm',

        resolve: {
            locations: locationsResolver,
            mainGroups: mainGroupsResolver,
            brands: brandsResolver,
            collections: collectionsResolver
        }
    });
}
// @ngInject
function locationsResolver(StockLogisticsApiService) {
    return StockLogisticsApiService.getLocations();
}
// @ngInject
function mainGroupsResolver(MaingroupsApiService) {
    return MaingroupsApiService.getMainGroups();
}
// @ngInject
function brandsResolver(BrandsApiService) {
    return BrandsApiService.getBrands();
}
// @ngInject
function collectionsResolver(ProductsApiService) {
    return ProductsApiService.getArticleCollections();
}

// @ngInject
function MassHandlingOrderingPointsController($state, $scope, $translate, ToasterService, locations, mainGroups, brands, collections
    ,StockLogisticsApiService, MaingroupsApiService, BrandsApiService, ProductsApiService, loadSpinnerService) {
    var vm = this;

    vm.stepHandler = {
        currentStep: 0,
        steps : ['Generic Selection', 'Specific Selection', 'Confirm Selection']
    }

    vm.locations = locations;
    vm.mainGroups = mainGroups;
    vm.brands = brands;
    vm.collections = collections;
    vm.locations.sort((a,b) => (a.locationType.id > b.locationType.id) ? 1: ((b.locationType.id > a.locationType.id) ? -1 : 0));
    vm.mainGroups.sort((a,b) => (a.mainGroupDescription > b.mainGroupDescription) ? 1: ((b.mainGroupDescription > a.mainGroupDescription) ? -1 : 0));
    vm.brands.sort((a,b) => (a.brandDescription > b.brandDescription) ? 1: ((b.brandDescription > a.brandDescription) ? -1 : 0));
    vm.collections.sort((a,b) => (a.collectionCode > b.collectionCode) ? 1: ((b.collectionCode > a.collectionCode) ? -1 : 0));

    vm.locationFilter = "";
    vm.mainGroupFilter = "";
    vm.brandFilter = "";
    vm.collectionFilter = "";
    vm.filterIsCurrent = false;

    vm.filteredLocations = [];
    vm.filteredMainGroups = [];
    vm.filteredBrands = [];
    vm.filteredCollections = [];

    vm.filterChanged = filterChanged;
    vm.goToNextStep = goToNextStep;
    vm.goToPreviousStep = goToPreviousStep;
    vm.validSelection = validSelection;
    vm.selectFilterSelection = selectFilterSelection;
    vm.deselectSelection = deselectSelection;

    activate();

    function addStartProperties (){
        _.forEach(vm.locations, function(location){
            location.selected = false;
        });
        _.forEach(vm.mainGroups, function(maingroup){
            maingroup.selected = false;
        });
        _.forEach(vm.brands, function(brand){
            brand.selected = false;
        });
        _.forEach(vm.collections, function(collection){
            collection.selected = false;
        });

        vm.filteredLocations = angular.copy(vm.locations);
        vm.filteredMainGroups = angular.copy(vm.mainGroups);
        vm.filteredBrands = angular.copy(vm.brands);
        vm.filteredCollections = angular.copy(vm.collections);

        filterChanged('location');
        filterChanged('mainGroup');
        filterChanged('brand');
        filterChanged('collection');
    }

    function activate() {
        console.log(vm.locations);
        console.log(vm.mainGroups);
        console.log(vm.brands);
        console.log(vm.collections);
        addStartProperties();
    }

    function filterChanged(type) {
        if(type === "location"){
            vm.filteredLocations = vm.locations.filter(function (location) { 
                if(location.selected) 
                    return true;
                else
                    return location.locationName.toLowerCase().includes(vm.locationFilter.toLowerCase())
            });      
        } else if(type === "mainGroup"){
            vm.filteredMainGroups = vm.mainGroups.filter(function (maingroup) { 
                if(maingroup.selected)     
                    return true;
                else
                    return maingroup.mainGroupDescription.toLowerCase().includes(vm.mainGroupFilter.toLowerCase())
            });
        } else if(type === "brand"){
            vm.filteredBrands = vm.brands.filter(function (brand) { 
                if(brand.selected)
                    return true;
                else
                    return brand.brandDescription.toLowerCase().includes(vm.brandFilter.toLowerCase())
            });
        } else if(type === "collection"){
            vm.filteredCollections = vm.collections.filter(function (collection) { 
                if(collection.selected) 
                    return true;
                else
                    return collection.collectionCode.toString().toLowerCase().includes(vm.collectionFilter.toLowerCase())
            });
        }   
    }

    function deselectSelection(type){
        if(type === "location"){
            for(let i = 0; i < vm.filteredLocations.length; i++){
                vm.filteredLocations[i].selected = false;
                vm.locationFilter = ""
            }
        } else if(type === "mainGroup"){
            for(let i = 0; i < vm.filteredMainGroups.length; i++){
                vm.filteredMainGroups[i].selected = false;
                vm.mainGroupFilter = ""
            }
        } else if(type === "brand"){
            for(let i = 0; i < vm.filteredBrands.length; i++){
                vm.filteredBrands[i].selected = false;
                vm.brandFilter = ""
            }
        } else if(type === "collection"){
            for(let i = 0; i < vm.filteredCollections.length; i++){
                vm.filteredCollections[i].selected = false;
                vm.collectionFilter = ""
            }
        }   

        filterChanged(type);
    }

    function selectFilterSelection(type){
        if(type === "location"){
            for(let i = 0; i < vm.filteredLocations.length; i++){
                vm.filteredLocations[i].selected = true;
                vm.locationFilter = ""
            }
        } else if(type === "mainGroup"){
            for(let i = 0; i < vm.filteredMainGroups.length; i++){
                vm.filteredMainGroups[i].selected = true;
                vm.mainGroupFilter = ""
            }
        } else if(type === "brand"){
            for(let i = 0; i < vm.filteredBrands.length; i++){
                vm.filteredBrands[i].selected = true;
                vm.brandFilter = ""
            }
        } else if(type === "collection"){
            for(let i = 0; i < vm.filteredCollections.length; i++){
                vm.filteredCollections[i].selected = true;
                vm.collectionFilter = ""
            }
        }   

        filterChanged(type);
    }

    function goToNextStep(){
        vm.stepHandler.currentStep++;
    }
    function goToPreviousStep(){
        vm.stepHandler.currentStep--;
    }

    function validSelection(){
        if(vm.filteredLocations.filter(function (obj)   {return obj.selected}).length === 0 || 
            vm.filteredMainGroups.filter(function (obj) {return obj.selected}).length === 0 || 
            vm.filteredBrands.filter(function (obj)     {return obj.selected}).length === 0 || 
            vm.filteredCollections.filter(function (obj){return obj.selected}).length === 0)
            return false
        else        
            return true;
    }
}

angular
    .module('stocklogistics.masshandlingorderingpoints', [])
    .config(stateConfig)
    .controller('MassHandlingOrderingPointsController', MassHandlingOrderingPointsController);